import Spinner from '@/components/common/spinner/Spinner.vue'
import { AxiosPlugin } from '@/plugins/AxiosPlugin'
import { BaseUrlPlugin } from '@/plugins/BaseUrlPlugin'
import { DecimalFilter } from '@/plugins/DecimalFilter'
import AttributeLabelsModule from '@/store/AttributeLabelsModule'
import { StorePlugin } from '@/store/store'
import Vue from 'vue'
import App from './App.vue'
import router from './router'

const VueGoogleMaps = require('vue2-google-maps') // eslint-disable-line @typescript-eslint/no-var-requires

Vue.config.productionTip = false
Vue.use(AxiosPlugin)
Vue.use(BaseUrlPlugin)
Vue.use(StorePlugin([AttributeLabelsModule]))
Vue.filter('decimal', DecimalFilter)

Vue.component('spinner', Spinner)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB6n6PQ4OWlCgijYe90VZof-6wc0Tx3sII'
  },
  installComponents: true
})

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
